import { useEffect, useState, useContext }      from "react";
import api                                      from "../../services/api";
import { usePxoPage }                           from "../../contexts/PxoPageContext";
import PxoDemandaTableContainer                 from "../Table/PxoDemandTableContainer";
import EmptyResultSection                       from "./emptyResultSection";

const PxoDemandSection = () => {

    const [ content, setContet ] = useState(null)

    const { selectedDate, selectedHorizonTypeId, pxoId, updateDemandSection } = usePxoPage()

    const fetchDemandsPxoTables = async () => {

        try{

            if (!pxoId) return

            const response = await api.get(`/getDemandPostByPxoId/${pxoId}`);

            const { demandPosts } = response.data
            setContet(demandPosts)

        }catch(error){

            setContet("Erro ao buscar dados", error)
        }

    }

    useEffect(()=> {

        fetchDemandsPxoTables()

    }, [ pxoId, updateDemandSection ])

    const hasDemands = Array.isArray(content) && content.length > 0

    return (
        
        <section className="flex flex-col gap-4 w-fit">
            
            <h2>Demandas</h2>

            {hasDemands ? (
                content.map((item, index) => (
                    <PxoDemandaTableContainer key={index} tableData={item} />
                ))
            ) : (
                <EmptyResultSection />
            )}
        </section>

    )

}

export default PxoDemandSection